import AppRouter from './routes/AppRouter'
import { ToastProvider } from './hooks/useToast'
import { SyncProvider } from './contexts/SyncContext'

export default function App() {
  return (
    <ToastProvider>
      <SyncProvider>
        <AppRouter />
      </SyncProvider>
    </ToastProvider>
  )
}
